const spaceQueryKeys = {
  spacePreviewResources: (spaceId) => [
    "space-resources",
    spaceId
  ],
  spaceWebnoteResources: (spaceId) => [
    "space-resources-webnotes",
    spaceId
  ],
  spacesAll: (includeInbox) => [
    "spaces",
    includeInbox ? "inbox" : ""
  ],
  space: (spaceId) => [
    "space",
    spaceId
  ]
};

export { spaceQueryKeys };
//# sourceMappingURL=spacesQueryKeys.js.map
